import { VStack } from "@chakra-ui/react";
import React, { RefObject } from "react";
import { colors } from "../../Theme";
import Billing from "./Billing";
import Calculator from "./Calculator";
import ObjectInfo from "./ObjectInfo";
import ElementSwitcher from "./ElementSwitcher";
import ActionsHistory from './ActionsHistory';
import ModalTextures from "../Modals/Textures";

type CalcItem = {
  skey: string;
  price: number;
  name: string;
};

class RightColumn extends React.Component<
  {
    canvasRef: RefObject<HTMLCanvasElement>;
    compassRef: RefObject<HTMLDivElement>;
  },
  {
    items: any[];
    total: number;
    panelsOpen: {
      calculator: boolean;
      count: boolean;
      objectInfo: boolean;
    };
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      panelsOpen: {
        calculator: true,
        count: true,
        objectInfo: true,
      },
      total: 0,
      items: [],
    };
    this.print = this.print.bind(this);
  }

  printGroup(group: CalcItem[], name: string, names: string) {
    if (group.length === 0) return "";
    let result = `<tr><td colspan="2"><i>${
      group.length === 1 ? name : names
    }</i></td></tr>`;
    for (const item of group) {
      result += `<tr>
          <td>${item.name}</td>
          <td>${item.price ? item.price + " р." : "-"}</td>
      </tr>`;
    }
    return result;
  }
  print() {
    if (!this.props.canvasRef || !this.props.canvasRef.current) return;
    const dataURL = this.props.canvasRef.current.toDataURL("image/png", 1);

    var windowContent = `
    <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <title>Печать макета</title>
      </head>
      <body>
      <style>
        @page {
          margin: 0;
        }
        @media screen {
          body {
            display:none;
          }
        }
        @media print {
          body {
            display:block;
          }
        }
        :root {
          --height: calc(21cm - 1.27cm * 2);
          --width: calc(29.7cm - 1.27cm * 2);
        }

        body {
            /* A4 */
            margin: 1.27cm!important;
            width: --width;
            height: --height;
            margin: 0;
            font-size: 16px;
            background-color: #e0dbcf;
        }
        
        .content {
            display: flex;
            position: "relative";
        }
        
        .form {
            width: 400px;
            max-height: 100%;
            padding-left: 30px;
        }
        
        .form table {
            width: 100%;
            border-spacing: 0;
        }
        
        .form table tbody tr td {
            padding: 5px;
            border-bottom: 1px solid gray;
            word-break: break-word;
        }
        
        .form table tr td:nth-child(2) {
            text-align: center;
            border-left: 0;
            word-break: keep-all;
        }
        
        .image {
            width: calc(--width * .8);
            height: --height;
        }
        
        .image img {
            max-width: 100%;
            max-height: 100%;
        }
        .compass {
          width: 120px;
          position: absolute;
          top: 20px;
          left: 20px;
        }
    </style>
    <div class="content">
      <div class="compass">${this.props.compassRef.current?.outerHTML}</div>
      <div class="image">
        <img src=${dataURL} />
      </div>
      <div class="form">
        <table>
          <thead>
            <tr>
              <th colspan="2">Состав</th>
            </tr>
          </thead>
        <tbody>`;
    let total = 0;
    for (const item of this.state.items) {
      windowContent += `<tr><td>${item.name}</td><td>${
        item.price !== 0 ? `${item.price}р` : "-"
      }</td>`;
      total += item.price;
    }
    windowContent += `
              <tr>
                  <td><b>Итог</b></td>
                  <td><b>${total} р.</b></td>
              </tr>`;
    windowContent += `</tbody>
            </table>
        </div>
    </div>
</body>

</html>
        `;

    let printWin: Window | null = window.open(); //'', '', 'width=340,height=260'
    if (!printWin) return;
    printWin.document.open();
    printWin.document.write(windowContent);
    printWin.document.close();

    printWin.onload = () => {
      if (printWin) printWin.print();
    };
    printWin.onafterprint = (event) => {
      if (printWin) printWin.close();
    };
  }
  saveScreenshot() {
    if (!this.props.canvasRef || !this.props.canvasRef.current) return;
    var link = document.createElement("a");
    link.download = "Скриншот эскиза";
    link.href = this.props.canvasRef.current.toDataURL("image/png", 1);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  render() {
    return (
      <VStack w="25%" bg={colors.badgeLight}>
        <ElementSwitcher />
        <ObjectInfo />
        <ActionsHistory />
        <Billing
          print={this.print.bind(this)}
          saveScreenshot={this.saveScreenshot.bind(this)}
        />
        <Calculator />
        <ModalTextures />
      </VStack>
    );
  }
}
export default RightColumn;
